<template>
    <div class='products-container' :style='[styles, custom_styles.products]' :class="[classes.products]"> 
        <template v-for='product in products' :key='product.code'>
            <ProductCard :product='product' :page_builder_mode='page_builder_mode'/>
        </template>
        <div v-if='loading' class='loading-container'><Loading/></div>
        <div class='no-poducts-set-text' v-if='!loading && products.length == 0'>
            No products set
        </div>
    </div>
</template>

<script>
import Field from "@/ecom/components/fields/Field.vue";
import Button from "@/ecom/components/buttons/Button.vue";
import ProductCard from '@/ecom/components/products/ProductCard.vue';
import Loading from '@/ecom/components/loading/Loading.vue';
import {checkAuth} from "@/global/modules/functions.js";
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {Field, Button, ProductCard, Loading},
    props:['element', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            errors: {},
            email: '',
            styles:{},
            products: [],
            loading: true,
            classes: {
                products: {}
            }
        }
    },
    methods:{
        setStyles(){
            this.styles = this.element.element_config.compiled_styles;
        },
        async getRecommendedProducts(){
            this.loading = true;
            let response = await fetch(`/api/products/recommendations`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.products = results;
                this.loading = false;
            }
        },
        async getProducts(){
            this.loading = true;

            let response = await fetch(`/api/products/get-by-ids?products=${JSON.stringify(this.element.element_config.config.products)}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.products = results;
                this.loading = false;
            }
        },
        setClasses(){
            if(this.element.element_config.compiled_classes != null){
                this.classes.products = this.element.element_config.compiled_classes.products;
            }
        },
    },
    watch:{
       'element': {
            handler(){
                this.setStyles();
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
                this.setClasses();
            },
            deep: true
        },
       'element.element_config.config.products': {
            handler(){
                 if(this.element.element_config.config.type == 'manual'){ //If manual, re-get products when adding / removing
                    this.getProducts();
                 }
            },
            deep: true
        },
        'element.element_config.config.type': function(){
            this.products = [];

            if(this.element.element_config.config.type == 'manual'){
                this.getProducts();
            }

            if(this.element.element_config.config.type == 'recommended'){
                this.getRecommendedProducts();
            }
         }
    },
    mounted(){
        this.setStyles();
        this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
        this.setClasses();
        
        if(this.element.element_config.config.type == 'manual'){
            this.getProducts();
        }

        if(this.element.element_config.config.type == 'recommended'){
            this.getRecommendedProducts();
        }
    }
}
</script>

<style lang="scss" scoped>
.products-container{
    display: grid;
    grid-template-columns: repeat(auto-fit, var(--product-card-width));
    width: 100%;
}

.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
}

.no-poducts-set-text{
    text-align: center;
    font-size: 1.2rem;
    padding: 24px 0px;
}

</style>